// @owners { team: patients }
import { Illustration } from '@alto/design-system';
import React from 'react';
import { getImage } from '~shared/assets/images/getImage';
import { getImageAltText } from '~shared/assets/images/getImageAltText';

export const BagWithMedicationsImage = () => {
  return (
    <Illustration
      size="xl"
      objectFit="contain"
      resizeMode="contain"
      source={getImage('onboardingLanding')}
      accessibilityLabel={getImageAltText('onboardingLanding')}
      testID={'med-bag-image'}
    />
  );
};
